import { Box, Typography } from "@mui/material";
import { useMemo, type JSX } from "react";

/**
 * This component takes format text and returns a typography
 * component that matches parent text, but highlights
 * inline variables indicated by ${} in blue, and removes
 * the brackets.
 *
 * @param text The text to format
 * @returns React component Typography using span (can be nested)
 */
const HighlightVariables = ({ text }: { text?: string }): JSX.Element => {
  const parts = useMemo(() => {
    if (!text) return undefined;
    return text.split(/\${([^}]+)}/g);
  }, [text]);

  const mapped = useMemo(() => {
    if (!parts) return undefined;
    return parts.map((part, index) => {
      if (index % 2 === 1) {
        return (
          <Box
            key={index}
            component="span"
            sx={(theme) => ({
              backgroundColor: `${theme.palette.primary.main}20`,
              padding: "2px 6px",
              borderRadius: "4px",
              color: `${theme.palette.primary.main}`,
              mx: 0.1,
            })}
          >
            {part}
          </Box>
        );
      }
      return <span key={index}>{part}</span>;
    });
  }, [parts]);

  if (!parts || !mapped || text == "" || text == " ") return <></>;

  return (
    <Typography component="span" variant="inherit">
      {mapped}
    </Typography>
  );
};

export default HighlightVariables;
